<template>
  <div class="license-plate" v-bind:class="{ large: large, 'inside-select': insideSelect }">
    <img src="/assets/img/dutch_license_plate.png"/><span>{{ formattedLicensePlate }}</span>
  </div>
</template>

<script type="text/javascript">
import {KentekenCheck} from 'rdw-kenteken-check/src/kenteken-check-nl-class'

export default {
  name: "LicensePlateComponent",
  props: {
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    insideSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    licensePlate: {
      type: String,
      required: true,
    }
  },
  computed: {
    formattedLicensePlate: function () {
      let licensePlateFormatter = new KentekenCheck('');

      if (licensePlateFormatter.matchLicense(this.licensePlate)) {
        return licensePlateFormatter.showLicense(this.licensePlate);
      }

      return this.licensePlate;
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

.license-plate {
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 2px;
}

.license-plate.inside-select {
  line-height: 15px;
  margin-top: -4px;
}

.license-plate img {
  background-color: #2463A8;
  display: inline-block;
  width: 18.5px;
  padding: 5px;
  vertical-align: bottom;
}

.license-plate.inside-select img {
  height: 21px;
  width: 14px;
  padding: 3px;
}

.license-plate.large img {
  width: 26px;
}

.license-plate span {
  text-transform: uppercase;
  background-color: #F5BD04;
  font-family: "Kenteken";
  font-size: 14px;
  padding: 3px 5px;
  color: #2d2c2c;
  display: inline-block;
}

.license-plate.inside-select span {
  font-size: 12px;
}

.license-plate.large span {
  font-size: 24px;
}
</style>
